
import { VillaCard } from './VillaCard';

const villas = [
  {
    id: 1,
    name: 'Radisson Blu - Maldives',
    description: 'Perfect for honeymoons, family getaways, and unforgettable ocean adventures.',
    price: '₹2,65,000',
    image: '/images/signature-collection-1.jpg'
  },
  {
    id: 2,
    name: 'Club Med Bali',
    description: 'Perfect for honeymoons, family getaways, and unforgettable ocean adventures.',
    price: '₹2,65,000',
    image: '/images/signature-collection-1.jpg'
  },
  {
    id: 3,
    name: 'Club Med Phuket',
    description: 'Perfect for honeymoons, family getaways, and unforgettable ocean adventures.',
    price: '₹2,65,000',
    image: '/images/signature-collection-1.jpg'
  },
  {
    id: 4,
    name: 'Club Med Mauritius',
    description: 'Perfect for honeymoons, family getaways, and unforgettable ocean adventures.',
    price: '₹2,65,000',
    image: '/images/signature-collection-1.jpg'
  }
];

export function SignatureCollectionsSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Signature Collections
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our handpicked selection of luxury villas and resorts,
            each offering unique experiences in the world's most beautiful destinations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {villas.map((villa) => (
            <VillaCard key={villa.id} villa={villa} />
          ))}
        </div>
      </div>
    </section>
  );
}
